import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import rootReducer from "../redux/reducers";
import rootSaga from "../redux/sagas";

// Add Middleware
const sagaMiddleware = createSagaMiddleware();

// Congifure Store
const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(sagaMiddleware),
});

// Run saga
sagaMiddleware.run(rootSaga);

export { configureStore };

export default store;
